import axios from 'axios';
import router from '../router'; 

// Helper to get base URL and Auth Token
const getApiConfig = () => {
  const userToken = localStorage.getItem('userToken');
  if (!userToken) {
    // router.push({ name: 'login' }); // Commented out for dev, uncomment for prod
    console.error('No user token, redirecting to login.');
    throw new Error('No user token, redirecting to login.');
  }
  const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
  return {
    baseURL,
    headers: { Authorization: `Bearer ${userToken}` }
  };
};

const state = {
  searchResults: [],
  isLoading: false,
};

const mutations = {
  SET_SEARCH_RESULTS(state, results) {
    state.searchResults = results;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  CLEAR_RESULTS(state) {
    state.searchResults = [];
  }
};

const actions = {
  /**
   * Fetches serial numbers based on search criteria
   */
  async performSearch({ commit }, { searchParams }) {
    commit('SET_LOADING', true);
    commit('CLEAR_RESULTS');
    try {
      const { baseURL, headers } = getApiConfig();
      
      // Filter out empty params
      const cleanParams = Object.fromEntries(
        Object.entries(searchParams).filter(([_, v]) => v != null && v !== '')
      );

      const response = await axios.get(`${baseURL}/serial-search`, {
        params: cleanParams,
        headers,
      });
      
      commit('SET_SEARCH_RESULTS', response.data);
      return response.data;
    } catch (error) {
      console.error('Error performing serial search:', error);
      if (error.response && error.response.status === 404) {
        commit('SET_SEARCH_RESULTS', []); // Clear results on 404
        return { message: "Nothing was found" };
      }
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * Triggers the server to create an Excel/CSV file and returns the file info
   */
  async exportToExcel({ commit }, { searchParams }) {
    try {
      const { baseURL, headers } = getApiConfig();

      // Filter out empty params and add excel=true
      const cleanParams = Object.fromEntries(
        Object.entries(searchParams).filter(([_, v]) => v != null && v !== '')
      );
      cleanParams.excel = 'true';

      const response = await axios.get(`${baseURL}/serial-search`, {
        params: cleanParams,
        headers,
      });
      
      return response.data; // Returns { message: "...", file: {...} }
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
